<script>
import {
  ArrowUpIcon,
  UserIcon,
  MailIcon,
  KeyIcon,
  VideoIcon,
  MonitorIcon,
  HeartIcon,
  EyeIcon,
  BoldIcon,
  FeatherIcon,
  CodeIcon,
  UserCheckIcon,
  GitMergeIcon,
  SettingsIcon,
  ArrowRightIcon,
  ChevronRightIcon,
} from "vue-feather-icons";

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import News from "@/components/news";

/**
 * Index-landing-four component
 */
export default {
  components: {
    Navbar,
    Footer,
    News,
    ArrowUpIcon,
    MailIcon,
    KeyIcon,
    VideoIcon,
    UserIcon,
    MonitorIcon,
    HeartIcon,
    EyeIcon,
    BoldIcon,
    FeatherIcon,
    CodeIcon,
    UserCheckIcon,
    GitMergeIcon,
    SettingsIcon,
    ArrowRightIcon,
    ChevronRightIcon,
  },
  data() {
    return {};
  },
};
</script>

<template>
  <div>
    <header
      id="topnav"
      class="defaultscroll sticky"
      style="background-color: white;"
    >
      <div class="container">
        <!-- Logo container-->
        <div>
          <router-link to="/" class="logo"
            ><img src="images/storagebox_dark.png" height="35" alt=""
          /></router-link>
        </div>
        <div class="buy-button">
          <router-link to="#" class="btn btn-primary">Inquire Now</router-link>
        </div>
        <!--end login button-->
        <!-- End Logo container-->
        <div class="menu-extras">
          <div class="menu-item">
            <!-- Mobile menu toggle-->
            <a
              class="navbar-toggle"
              @click="toggleMenu()"
              :class="{ open: isCondensed === true }"
            >
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
            <!-- End mobile menu toggle-->
          </div>
        </div>

        <div id="navigation">
          <!-- Navigation Menu-->
          <!-- <ul
            class="navigation-menu"
            v-scroll-spy-active="{ selector: 'li.has-submenu' }"
          >
            <li class="has-submenu">
              <a href="javascript: void(0);" v-scroll-to="'#home'">Home</a>
            </li>
            <li class="has-submenu">
              <a href="javascript: void(0);" v-scroll-to="'#rooms'">Rooms</a>
            </li>
            <li class="has-submenu">
              <a href="javascript: void(0);" v-scroll-to="'#services'"
                >Services</a
              >
            </li>
            <li class="has-submenu">
              <a href="javascript: void(0);" v-scroll-to="'#contact'"
                >Contact</a
              >
            </li>
          </ul> -->
          <!--end navigation menu-->
        </div>
        <!--end navigation-->
      </div>
      <!--end container-->
    </header>

    <!-- Start Hero -->
    <section
      class="bg-half-170 bg-light d-table w-100"
      style="background-image: url('images/bg-2.jpg');"
    >
      <div class="container">
        <div class="row align-items-center mt-5">
          <div class="col-lg-7 col-md-6">
            <div class="title-heading">
              <h4 class="heading my-3">
                Pack, Pickup, Store
              </h4>
              <p class="para-desc text-muted">
                We'll securely store your items.
              </p>

              <div class="mt-4 pt-2">
                <a href="javascript:void(0)" class="btn btn-primary m-1"
                  >Contact Us Now</a
                >
              </div>
            </div>
          </div>

          <div class="col-lg-5 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <div class="card shadow rounded border-0 ml-lg-4">
              <div class="card-body">
                <h5 class="card-title text-center">Book with Us Now</h5>

                <form class="login-form mt-4">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label
                          >Full Name <span class="text-danger">*</span></label
                        >
                        <div class="position-relative">
                          <user-icon class="fea icon-sm icons"></user-icon>
                          <input
                            type="text"
                            class="form-control pl-5"
                            placeholder="First Name"
                            name="s"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label
                          >Your Email <span class="text-danger">*</span></label
                        >
                        <div class="position-relative">
                          <mail-icon class="fea icon-sm icons"></mail-icon>
                          <input
                            type="email"
                            class="form-control pl-5"
                            placeholder="Email"
                            name="email"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label
                          >Your Contact Number
                          <span class="text-danger">*</span></label
                        >
                        <div class="position-relative">
                          <phone-icon class="fea icon-sm icons"></phone-icon>
                          <input
                            type="phone"
                            class="form-control pl-5"
                            placeholder="Phone Number"
                            name="contact"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <button class="btn btn-block btn-primary">
                        Book for Pickup
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--end section-->
    <!-- End Hero -->

    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="section-title text-center mb-4 pb-2">
              <span class="badge badge-pill badge-soft-primary">Features</span>
              <h4 class="title mt-3 mb-4">Store your Boxes with Us</h4>
              <p class="text-muted para-desc mx-auto mb-0">
                Keep your valuable goods with us, hassle free.
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
          <div class="col-lg-4 col-md-6 mt-4 pt-2">
            <div
              class="card border-0 text-center features feature-clean rounded"
            >
              <div class="icons text-primary text-center mx-auto">
                <i class="uil uil-envelope-lock d-block rounded h3 mb-0"></i>
              </div>

              <div class="card-body p-0 mt-4">
                <h5>Fully Secured</h5>
                <p class="text-muted mb-0">
                  All your items are fully secured 24/7.
                </p>
                <!-- <div class="mt-2">
                  <a href="javascript:void(0)" class="text-primary"
                    >Read More
                    <arrow-right-icon class="fea icon-sm"></arrow-right-icon
                  ></a>
                </div> -->
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-4 col-md-6 mt-4 pt-2">
            <div
              class="card border-0 text-center features feature-clean rounded"
            >
              <div class="icons text-primary text-center mx-auto">
                <i class="uil uil-edit d-block rounded h3 mb-0"></i>
              </div>

              <div class="card-body p-0 mt-4">
                <h5>Easy Access</h5>
                <p class="text-muted mb-0">
                  You will have 24/7 access to your box whenever you need.
                </p>
                <!-- <div class="mt-2">
                  <a href="javascript:void(0)" class="text-primary"
                    >Read More
                    <arrow-right-icon class="fea icon-sm"></arrow-right-icon
                  ></a>
                </div> -->
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-4 col-md-6 mt-4 pt-2">
            <div
              class="card border-0 text-center features feature-clean rounded"
            >
              <div class="icons text-primary text-center mx-auto">
                <i class="uil uil-circle-layer d-block rounded h3 mb-0"></i>
              </div>

              <div class="card-body p-0 mt-4">
                <h5>Hassle Free Storing</h5>
                <p class="text-muted mb-0">
                  Just send your parcels here and we'll take care of it
                </p>
                <!-- <div class="mt-2">
                  <a href="javascript:void(0)" class="text-primary"
                    >Read More
                    <arrow-right-icon class="fea icon-sm"></arrow-right-icon
                  ></a>
                </div> -->
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->

      <!--end container-->
    </section>
    <!--end section-->

    <!-- Start -->
    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">Our Prices</h4>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
          <!-- Table Start -->
          <div class="col mt-4 pt-2" id="tables">
            <div class="component-wrapper rounded shadow">
              <div class="p-4 border-bottom">
                <h4 class="title mb-0">Standard Box Sizes</h4>
              </div>

              <div class="p-4">
                <div class="table-responsive bg-white shadow rounded">
                  <table class="table mb-0 table-center">
                    <thead>
                      <tr>
                        <th scope="col">Package</th>
                        <th scope="col">Size</th>
                        <th scope="col">Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Balikbayan Medium</th>
                        <td>18"x16"x18"</td>
                        <td>P250/month</td>
                      </tr>
                      <tr>
                        <th scope="row">Balikbayan Large</th>
                        <td>18"x18"x24"</td>
                        <td>P350/month</td>
                      </tr>
                      <tr>
                        <th scope="row">Balikbayan Extra Large</th>
                        <td>24"x18"x24"</td>
                        <td>P500/month</td>
                      </tr>
                      <tr>
                        <th scope="row">Document/Archive Box A</th>
                        <td>16"x11"x11"</td>
                        <td>P200/month</td>
                      </tr>
                      <tr>
                        <th scope="row">Document/Archive Box B</th>
                        <td>16"x16"x12"</td>
                        <td>P250/month</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!--end col-->
          <!-- Table End -->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- End -->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
